// import { ofetch } from 'ofetch'

// export const isLoading = ref(false)
// export const $api = ofetch.create({
//   baseURL: import.meta.env.VITE_APP_API_URL || '/api',
//   async onRequest({ options }) {
//     isLoading.value = true

//     const accessToken = useCookie('accessToken').value
//     if (accessToken)
//       options.headers.append('Authorization', `Bearer ${accessToken}`)
//   },
//   // async onResponse({ response }) {
//   //   isLoading.value = false // Hide loading on success
//   // },

//   async onResponseError({ response }) {
//     isLoading.value = false // Hide loading on error
//   },
// })


import { ofetch } from 'ofetch'
import { ref } from 'vue' // Assuming you're using Vue 3
import { useAuthStore } from '@/stores/Authentication'

export const isLoading = ref(false)
export const $api = ofetch.create({
  baseURL: import.meta.env.VITE_APP_API_URL || '/api',
  async onRequest({ options }) {
    isLoading.value = true // Show loading

    const accessToken = useCookie('accessToken').value
    if (accessToken) {

      // check if token is expired route to login page
      const authStore = useAuthStore()
      
      authStore.routToLoginPageIfTokenExpired()

      // Ensure headers object exists
      options.headers = options.headers || {}

      // Set Authorization header
      options.headers.append('Authorization', `Bearer ${accessToken}`)
    }

    // Ensure the body is properly serialized
    if (options.body && typeof options.body === 'object') {
      options.body = JSON.stringify(options.body) // Manually serialize the body
      options.headers['Content-Type'] = 'application/json' // Set Content-Type header
    }

  },
  async onResponse({ response }) {
    isLoading.value = false 

    return response // Ensure the response is returned
  },
  async onResponseError({ response }) {
    console.log('responseError in $api')
    isLoading.value = false 

    throw response // Ensure the error is thrown
  },
})
